var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSparkles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24961 2.80005C6.02624 4.09182 7.10783 5.17342 8.39961 5.95005C7.10783 6.72668 6.02624 7.80827 5.24961 9.10005C4.47298 7.80827 3.39138 6.72668 2.09961 5.95005C3.39138 5.17342 4.47298 4.09182 5.24961 2.80005Z",
    fill: "#9747FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 2.80005C10.8448 3.37417 11.3255 3.85488 11.8996 4.20005C11.3255 4.54522 10.8448 5.02593 10.4996 5.60005C10.1544 5.02593 9.67373 4.54522 9.09961 4.20005C9.67373 3.85488 10.1544 3.37417 10.4996 2.80005Z",
    fill: "#9747FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7.69995C9.18146 8.4176 9.78235 9.01849 10.5 9.44995C9.78235 9.88141 9.18146 10.4823 8.75 11.2C8.31854 10.4823 7.71765 9.88141 7 9.44995C7.71765 9.01849 8.31854 8.4176 8.75 7.69995Z",
    fill: "#9747FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/Sparkles.b0134192a152612054c1bdfa7d25fb03.svg";
export { ForwardRef as ReactComponent };